import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { app } from '../firebase';

const functions = getFunctions(app, 'europe-west1');

if (process.env.NODE_ENV === 'development') {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch {
    // Already connected
  }
}

const VISMA_SCOPE = [
  'openid',
  'offline_access',
  'vismanet_erp_interactive_api:read',
].join(' ');

class VismaAuth {
  constructor() {
    this.clientId = process.env.REACT_APP_VISMA_CLIENT_ID || 'isv_svenry-app';
    this.redirectUri = process.env.REACT_APP_VISMA_REDIRECT_URI
      || (typeof window !== 'undefined' ? `${window.location.origin}/visma/callback` : 'https://app.svenry.com/visma/callback');

    this.exchangeCodeFunction = httpsCallable(functions, 'exchangeVismaCode');
    this.saveTokensFunction = httpsCallable(functions, 'saveVismaTokens');
    this.getStatusFunction = httpsCallable(functions, 'getVismaStatus');
    this.refreshTokenFunction = httpsCallable(functions, 'refreshVismaToken');
  }

  generateSecureState() {
    if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
      const array = new Uint32Array(4);
      window.crypto.getRandomValues(array);
      return Array.from(array, (dec) => dec.toString(36)).join('');
    }
    return Math.random().toString(36).slice(2, 15) + Math.random().toString(36).slice(2, 15) + Date.now().toString(36);
  }

  getAuthorizationUrl(state = null) {
    if (!this.clientId) {
      throw new Error('Visma Client ID not configured (REACT_APP_VISMA_CLIENT_ID)');
    }
    const stateValue = state || this.generateSecureState();
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem('visma_oauth_state', stateValue);
    }

    const params = new URLSearchParams({
      client_id: this.clientId,
      redirect_uri: this.redirectUri,
      response_type: 'code',
      scope: VISMA_SCOPE,
      state: stateValue,
    });

    return `https://connect.visma.com/connect/authorize?${params.toString()}`;
  }

  async exchangeCodeForToken(code, state) {
    const result = await this.exchangeCodeFunction({
      code,
      redirectUri: this.redirectUri,
      state,
    });
    return result.data;
  }

  async saveTokens(tokens) {
    const result = await this.saveTokensFunction({
      accessToken: tokens.accessToken,
      refreshToken: tokens.refreshToken,
      expiresIn: tokens.expiresIn,
      expiresAt: tokens.expiresAt,
      tenantId: tokens.tenantId,
      tenantExternalId: tokens.tenantExternalId,
    });
    return result.data;
  }

  async getConnectionStatus() {
    const result = await this.getStatusFunction();
    return result.data;
  }

  async refreshAccessToken() {
    const result = await this.refreshTokenFunction();
    return result.data;
  }

  connect() {
    if (!this.clientId) {
      throw new Error('Visma Client ID not configured. Add REACT_APP_VISMA_CLIENT_ID to your .env file and rebuild.');
    }
    const state = this.generateSecureState();
    window.location.href = this.getAuthorizationUrl(state);
  }
}

const vismaAuth = new VismaAuth();
export default vismaAuth;
